import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Zap, X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DISMISS_KEY = 'odyvoy_boost_promo_dismissed';

export const BoostPromoBanner = () => {
  const [dismissed, setDismissed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setDismissed(typeof window !== 'undefined' && localStorage.getItem(DISMISS_KEY) === '1');
  }, []);

  if (dismissed) return null;

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  const scrollToBoost = (attempts = 0) => {
    const el = document.getElementById('boost-passes');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (attempts < 20) {
      setTimeout(() => scrollToBoost(attempts + 1), 150);
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/pricing') {
      scrollToBoost();
    } else {
      navigate('/pricing#boost-passes');
      setTimeout(() => scrollToBoost(), 200);
    }
  };

  return (
    <section className="home-container pb-14 pt-4 sm:pb-16" aria-label="Boost Pass offer">
      <div className="relative flex flex-col justify-between gap-4 rounded-lg border border-border bg-secondary px-6 py-8 text-primary sm:flex-row sm:items-center sm:px-9">
        <div className="flex min-w-0 items-start gap-3 pr-8"><Zap className="mt-1 h-5 w-5 shrink-0" aria-hidden="true" /><div><p className="text-base font-semibold">A little extra for your next departure.</p><p className="mt-1 text-sm">Explore short-term access with a Boost Pass.</p></div></div>
        <Button variant="link" onClick={handleClick} className="home-text-action mr-4 self-start px-0 sm:self-center">Explore Boost Pass <ArrowRight aria-hidden="true" /></Button>
        <Button
          variant="ghost"
          size="icon"
          type="button"
          onClick={handleDismiss}
          aria-label="Dismiss boost promo banner"
          className="absolute right-1 top-1 h-12 w-12 shrink-0 text-primary hover:bg-primary/10"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};

export default BoostPromoBanner;
